/* eslint-disable */
// Debugger
import Debugger from "@/config/debugger";
const debug = new Debugger("main.js", true);

import Vue from "vue";
import App from "@/App.vue";
import router from "@/config/router";
import store from "@/config/store";

var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

// CONFIG
import config from "@/config/app";
import vuetify from "@/config/vuetify";
import { firebaseApp as firebase, dbProfiles } from "@/config/firebase";

// INIT i18n - mult-language support
import i18n from "@/config/vueI18n";
Vue.use(i18n);

// INSTALL VUE META
import VueMeta from "vue-meta";
Vue.use(VueMeta);

// UTILITY COMPONENTS
import LoadScript from "vue-plugin-load-script";
import Toasted from "vue-toasted";
import VTooltip from "v-tooltip";
Vue.use(LoadScript);
Vue.use(Toasted);
Vue.use(VTooltip);

// IMPORT GLOBAL COMPONENTS / CSS / JS
import "@/components";
import "@/assets/scss/main.scss";

//import { user } from "./modules/Auth/controller"
import dbContacts from "./components/Contact/contact.model";
import { user } from "./modules/Auth/controller";
import dbGames from "./modules/Games/games.controller";
import dbSmartForms from "./modules/SmartForms/smartforms.controller";

// vue-tour plugin
import VueTour from "vue-tour";
require("@/assets/vue-tour.css");
Vue.use(VueTour);
let tours = () => import("./components/tours.vue");
Vue.component("tours", tours);

// enable cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("3h");

// Global Variables to access this.$app
Vue.prototype.$eventHub = new Vue(); // EventHub
Vue.config.productionTip = false;

const appWorks = new Vue({
  i18n,
  router,
  store,
  vuetify,
  data: () => ({
    app: JSON.parse(JSON.stringify(config.app)),
    alert: {
      snackbar: false,
      text: "Alert Message",
      timeout: 1000, // any integer in ms
      // color: "#1E67C0",
      color: "#00ff00",
      mode: null, // vertical / multi-line default: null
      x: null, // left / right
      y: "top", // top / bottom
      dark: true,
    },
    systemBar: {
      show: false,
      color: "red",
      height: "24px",
      text: "No Connection or Some other Message",
    },
    topToolBar: {
      show: false,
      dense: true,
      // color: "#1f283e",
      color: "#00ff00",
      // src: require("@/assets/images/lmic-bg.jpg"),
      extended: false,
      flat: false,
    },
    default: {
      alert: {
        snackbar: true,
        text: "Alert Message",
        timeout: 1000, // any integer in ms
        color: "#1E67C0",
        mode: null, // vertical / multi-line default: null
        x: null, // left / right
        y: "top", // top / bottom
        dark: true,
      },
      systemBar: {
        show: true,
        color: "red",
        height: "24px",
        contents: "",
      },
    },
    currentUrl: null,
  }),
  computed: {
    dark() {
      // returns true of false
      return this.$vuetify.theme.themes.dark ? "dark" : "light";
    },
    color() {
      return this.$vuetify.theme.themes[this.dark];
    },
    appState: {
      get() {
        return this.state;
      },
      set(newVal) {
        console.log("newVal", newVal);
        return this.$set(this.state, "state", newVal);
      },
    },
  },
  watch: {
    "$app.user": {
      deep: true,
      handler(newVal) {
        console.log("$app.user newVal", newVal);
      },
    },
  },
  methods: {
    initApp() {
      console.log("app init");
      // Global States/Methods accessed through $app / this.$app
      Vue.prototype.$app = this.$store.state.app; // see ./config/app.js for default values

      this.$app.systemBar = this.systemBar;
      this.$app.topToolBar = this.topToolBar;
      this.$app.color = this.color;
      this.$app.alert = this.sendAlert;
      this.$app.alert2 = this.sendAlert2; // Todo: Integrate to Production or remove
      this.$app.toast = this.$toasted;
      this.$app.signOut = this.signOut;
      this.$app.data = this.$store.state;
      window.$app = this.$app; // Todo: Remove for Production unless testing
    },
    getContacts() {
      return dbContacts
        .getAll()
        .then((contacts) => {
          this.$app.data.contacts = contacts;
          this.getOrganizations();
          return { "getContacts done": contacts };
        })
        .catch((error) => {
          console.log("Error getting contacts: ", error);
        });
    },
    getOrganizations() {
      let contacts = this.$app.data.contacts;
      return new Promise((res) => {
        this.$app.data.organizations = contacts
          .map((obj) => {
            return obj.Organization;
          })
          .filter((item, index, arr) => {
            return (
              arr.indexOf(item) == index && item != undefined && item != ""
            );
          });
        res("organizations done");
      });
    },
    getGames() {
      return dbGames.getAll().then((data) => {
        this.$app.data.games = data;
        return { "getGames done": data };
      });
    },
    getForms() {
      return dbSmartForms.getAll().then((data) => {
        this.$app.data.smartForms = data;
        return { formsDone: data };
      });
    },
    sendAlert(alertObj) {
      let defaultAlert = Object.assign({}, this.default.alert);
      // if alertObj is a string convert to object
      alertObj =
        typeof alertObj === "string" || alertObj instanceof String
          ? { text: alertObj }
          : alertObj;
      this.alert = Object.assign(defaultAlert, alertObj);
    },
    sendAlert2(message, alertObj) {
      // clear all toasts
      if (message == "clear") {
        this.$toasted.clear();
        return;
      }
      alertObj = alertObj || {};
      let alertConfig = {};
      // testing alternate toast component
      let alertSchema = {
        default: {
          containerClass: "alerts-wrapper",
          type: "info", //'success', 'info', 'error'
          duration: 200000,
          iconPack: "mdi",
          single: true,
          action: [
            {
              text: "X",
              onClick: (e, toastObject) => {
                //console.log("this", toastObject)
                toastObject.goAway(0);
              },
            },
          ],
        },
        info: {
          type: "info",
          icon: "mdi-alert-circle",
        },
        error: {
          type: "error",
          icon: "mdi-alert",
        },
        warning: {
          type: "warning",
          icon: "mdi-alert-octagon-outline",
        },
      };

      let type = alertObj.type || "default";
      alertConfig = {
        ...alertSchema.default,
        ...alertSchema[type],
        ...alertObj,
      };
      message = `<div class="message">${message}</div>`;
      this.$toasted.show(message, alertConfig);
    },
    signOut() {
      // temp function
      const _this = this;

      firebase
        .auth()
        .signOut()
        .then(function () {
          // Sign-out successful.

          _this.$store.state.user.loggedIn = false;
          _this.$router.push("/sign-in");
        })
        .catch(function (error) {
          console.log("sign-out error", error);

          // An error happened.
        });
    },
    async getAppData(uid) {
      const defaultRoute = config.app.defaultPage;
      const currentRoute = this.$route;
      //console.log('uid', uid)
      const _this = this;
      const userDefault = JSON.parse(JSON.stringify(config.userDefault));

      // USER PROFILE
      let profile = dbProfiles
        .where("uid", "==", uid)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const userProfile = doc.data();
            userProfile["profile_uid"] = doc.id;
            userProfile["loggedIn"] = true; //

            //console.log(doc.id, " => ", doc.data());
            _this.$app.user = Object.assign(userDefault, userProfile);
          });
          return "Profile done";
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
      let contacts = this.getContacts();
      let orgs = this.getOrganizations();
      let events = this.getGames();
      let forms = this.getForms();
      await Promise.all([profile, contacts, events, forms]).then((data) => {
        console.log("Promise.all data", data);
        _this.$app.state = "ready";
      });
    },
  },
  created() {
    const _this = this;
    const defaultRoute = config.app.defaultPage;
    const currentRoute = this.$route;
    this.$router.afterEach((to, from) => {
      // REMEMBER CURRENT URL FOR 3 HOUR
      Vue.$cookies.set("currentUrl", to.path);
    });

    this.initApp();

    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        //console.log("signedIn", user);
        // User is signed in.
        _this.getAppData(user.uid);
        _this.$app.user.loggedIn = true;

        if (currentRoute.name != defaultRoute.name) {
          // IF CURRENT URL IS SAVED (EXPIRES AFTER 3 HOUR) REDIRECT TO THAT
          // IF NOT REDIRECT TO LAST URL IF LOGGED IN
          let currentUrl = Vue.$cookies.get("currentUrl");
          let redirect = currentUrl ? currentUrl : config.app.defaultPage;
          _this.$router.push(redirect);
        }
      } else {
        // No user is signed in.
        //console.log("user signedOut created");
        const userDefault = JSON.parse(JSON.stringify(config.userDefault));
        _this.$app.user = { ..._this.$app.user, ...userDefault };
        console.log("signedOut:_this.$app.user", _this.$app.user, userDefault);
        _this.$app.state = "signin";
        _this.$app.user.loggedIn = false;
      }
    });
  },
  mounted() {
    // document.addEventListener("click", (e) => {
    //   try {
    //     const regexExp = /^#[^ !@#$%^&*(),.?":{}|<>]*$/gi;
    //     if (regexExp.test(e.target.getAttribute("href"))) {
    //       e.preventDefault();
    //       var elements = document.querySelectorAll(".ce-header");
    //       elements.forEach((element) => {
    //         if (
    //           e.target.getAttribute("href").substring(1) ==
    //           element.getAttribute("data-anchor")
    //         ) {
    //           element.scrollIntoView({ behavior: "smooth", block: "start" });
    //         }
    //       });
    //     } else if (e.target.getAttribute("href").charAt(0) == "/") {
    //       // this.$router.push(e.target.getAttribute("href")).catch(() => {});
    //     }
    //   } catch (e) {
    //     console.log("error", e);
    //   }
    // });
  },
  render: (h) => h(App),
}).$mount("#app");

if (process.env.NODE_ENV === "development") {
  // if in development mode make app available in the windows console as appWorks
  window.appWorks = appWorks;
}
